import React from 'react';
import {Tooltip} from 'antd';
import {useTranslation} from 'react-i18next';
import {StarsIcon} from '../../icons';
import {colorsStyles} from '../../utils/styles';
import {StyledConfidenceCircle, StyledConfidenceTag, StyledConfidenceTooltipContent} from './StyledConfidenceBadge';
import IconWrapper from '../IconWrapper';
import {confidenceLevelConstants} from '../../constants';
import {textHelpers} from '../../utils/helpers';

const {HIGH, MEDIUM, LOW} = confidenceLevelConstants;

const confidenceConfig = {
  [HIGH]: {
    color: colorsStyles.success_600,
    bg: colorsStyles.success_25,
  },
  [MEDIUM]: {
    color: colorsStyles.primary_7,
    bg: colorsStyles.primary_2,
  },
  [LOW]: {
    color: colorsStyles.neutral_7,
    bg: colorsStyles.neutral_3,
  },
};

const ConfidenceBadge = ({suggestion}) => {
  const {t} = useTranslation('main');
  const {confidence, reasoning} = suggestion || {};
  const config = confidenceConfig[confidence];

  if (!config) return null;

  const {color, bg} = config;

  const tooltipContent = (
    <StyledConfidenceTooltipContent>
      <StyledConfidenceTag color={color} bg={bg}>{t(`confidence.${confidence}`)}</StyledConfidenceTag>
      {reasoning && <span>{textHelpers.cutString(reasoning, 300)}</span>}
    </StyledConfidenceTooltipContent>
  );

  return (
    <Tooltip title={tooltipContent} styles={{root: {maxWidth: 324}}}>
      <StyledConfidenceCircle bg={bg}>
        <IconWrapper color={color} size={12}>
          <StarsIcon />
        </IconWrapper>
      </StyledConfidenceCircle>
    </Tooltip>
  );
};

export default ConfidenceBadge;
